import { createRoot } from 'react-dom/client';
import { App as AntdApp } from 'antd';
import { PersistGate } from 'redux-persist/integration/react';
import '@xyflow/react/dist/style.css';

import './index.scss';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// third-party
import { Provider as ReduxProvider } from 'react-redux';

// apex-chart
import 'assets/third-party/apex-chart.css';

// project import
import App from './App';
import { persistor, store } from './store/store';
import { ConfigProvider } from 'contexts/ConfigContext';
import { StrictMode } from 'react';

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<StrictMode>
		<ConfigProvider>
			<ReduxProvider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<AntdApp style={{ height: '100%' }}>
						<App />
					</AntdApp>
				</PersistGate>
			</ReduxProvider>
		</ConfigProvider>
	</StrictMode>
);
